






































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Area from "@/models/coding/areaModel";
import IndicatorGroup from "@/models/indicator/indicatorGroup.model";
import baseSelect from '@/components/base/baseSelect/baseSelect.vue';
import IndicatorGroupService from '@/services/IndicatorGroupService';
@Component
export default class IndicatorGroupAdd extends GenericAdd<IndicatorGroup> {
  basedGroup : boolean = false;
  groupId:number = null;
  constructor() {
    super();
     this.controller = 'IndicatorGroups';
    this.model = new IndicatorGroup();
  }

   saveAll(){
      if(this.groupId !== null){
        debugger;
        this.saveBasedGroup();
        
      }else{
        debugger
        return this.validate();
      }
  }
 
  saveBasedGroup(){
    this.saving = true;
    var service = new IndicatorGroupService();
    service.saveGroup(this.groupId,this.model).then(response=>{
      this.operationSuccess();
      this.groupId= null;
      this.clean();
      this.saving = false;
    if(this.exitOnSave){
          this.$router.push(`${this.$router.currentRoute.path.split('/agregar')[0]}`)
        }
    }).catch((error) => this.operationFailed(error));
    
       
  }
  cancel(){ this.$router.push(`${this.$router.currentRoute.path.split('/agregar')[0]}`)}

}
